import React from 'react';
import * as Styled from './styles';

export const RequiredForm = () => (
  <Styled.RequiredStyled>*</Styled.RequiredStyled>
);
